import { Box, Typography, useTheme } from '@material-ui/core';

import { getColor } from '@vyce/core/src/theme/styles';

export const FormSummaryDateAnswer = ({
  value,
  count,
  onClick,
}: {
  value: string;
  count: number;
  onClick?: () => void;
}) => {
  const theme = useTheme();
  const color = getColor(theme.palette.type === 'light');

  return (
    <Box
      display="flex"
      alignItems="center"
      onClick={onClick}
      style={{
        backgroundColor: color.primaryBG,
        fontWeight: 500,
        borderRadius: 8,
        padding: '6px 12px',
        gap: 8,
        cursor: onClick ? 'pointer' : undefined,
      }}
    >
      <Typography variant="body2" style={{ fontWeight: 500, color: theme.palette.primary.dark }}>
        {value}
      </Typography>
      {count > 1 && (
        <Box
          style={{
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.text.primary,
            borderRadius: '50%',
            minWidth: 20,
            height: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 11,
            fontWeight: 600,
            padding: '0 4px',
          }}
        >
          {count}
        </Box>
      )}
    </Box>
  );
};
